// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"520":"fffadc2b","668":"8fa13eb4"}[chunkId] + ".chunk.js";
};